import * as types from "../constants/ActionTypes";

const isOpenFaqDragableReducer = (
  state = { isOpen: false, signal: null },
  action
) => {
  switch (action.type) {
    case types.CHANGE_IS_OPEN_FAQ_DRAGABLE:
      return {
        isOpen: action.status,
        signal: Date.now(),
      };
    default:
      return state;
  }
};

export default isOpenFaqDragableReducer;
